<template>
  <div class="card p-2">
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('From Date') }}
        <span class="text-muted" :title="__('Select the start date for export')">
          ({{ __('Required') }})
        </span>
      </div>
      <div class="text-right">
        <ConstrainedDatePicker :date="this.fromDate" :mode="'from'" @update-date="updateFromDate" />
      </div>
    </div>
    <div v-if="this.fromDate" class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('To Date') }}
        <span class="text-muted" :title="__('Select the end date for export')">
          ({{ __('Required') }})
        </span>
      </div>
      <div class="text-right">
        <ConstrainedDatePicker :date="this.toDate" :referenceDate="this.fromDate" :mode="'to'"
          @update-date="updateToDate" />
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Review Filter') }}
        <span class="text-muted" :title="__('Filter reviews')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.responseFilter ? __(labelizeResponse(filters.responseFilter)) : __('All') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Importance') }}
        <span class="text-muted" :title="__('Filter reviews by importance level')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.importance ? __(labelizeImportance(filters.importance)) : __('All') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
      {{ __('Review Type') }}
      <span class="text-muted">(Positive/Negative)</span>
      <span class="text-muted" :title="__('Filter reviews by rating')">(?)</span>
      </div>
      <div class="text-right">
      {{ filters.reviews ? __(labelizeReviews(filters.reviews)) : __('All') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Sources') }}
        <span class="text-muted" :title="__('Filter reviews by their sources')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.source && filters.source.length ? __(formattedSources) : __('All') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Review Language') }}
        <span class="text-muted" :title="__('Filter reviews by language')">(?)</span>
      </div>
      <div class="text-right text-truncate">
        {{ filters.language ? __(labelizeLanguage(filters.language)) : __('All') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Highlight all sentiment topics and terms') }}
        <span class="text-muted" :title="__('Show all sentiment-related topics and terms')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.showAllSentiment ? __('Yes') : __('No') }}
      </div>
    </div>
    <div class="d-flex justify-content-between py-2 border-bottom">
      <div>
        {{ __('Sentiment Category') }}
        <span class="text-muted" :title="__('Filter by specific sentiment category')">(?)</span>
      </div>
      <div class="text-right">
        {{ filters.sentimentCategory ? __(filters.sentimentCategory) : __('All') }}
      </div>
    </div>
  </div>
</template>

<script>
import ConstrainedDatePicker from '../generic/ConstrainedDatePicker.vue';

export default {
  components: {
    ConstrainedDatePicker,
  },

  props: {
    filters: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      fromDate: null,
      toDate: null,
    };
  },

  computed: {
    formattedSources() {
      return this.filters.source.map(source => this.labelizeSource(source)).join(', ');
    },
  },

  methods: {
    updateFromDate(newDate) {
      this.fromDate = newDate;
      this.toDate = null;
      this.$emit('update-export-date-range', this.fromDate, this.toDate);
    },

    updateToDate(newDate) {
      this.toDate = newDate;
      this.$emit('update-export-date-range', this.fromDate, this.toDate);
    },

    labelizeResponse(response) {
      const labels = {
        '': __('All Reviews'),
        noResponse: __('Not Responded'),
        hasResponse: __('Responded'),
        importantResponse: __('Important Only'),
        withComments: __('With Comments'),
        noComments: __('No Comments'),
        withSuggestions: __('With Suggestions'),
        AllSuggestions: __('All Suggestions'),
      };
      return labels[response] || __(response);
    },

    labelizeImportance(importance) {
      const labels = {
        '': __('All Importances'),
        high: __('High Importance'),
        medium: __('Medium Importance'),
        low: __('Low Importance'),
      };
      return labels[importance] || __(importance);
    },

    labelizeReviews(reviews) {
      const labels = {
        '': __('All Reviews'),
        positive: __('Positive'),
        negative: __('Negative'),
      };
      return labels[reviews] || __(reviews);
    },

    labelizeSource(source) {
      return this.sourceLabelFromSlug(source) || __(source);
    },

    labelizeLanguage(language) {
      const labels = {
        '': __('All Languages'),
        en: __('English'),
        fr: __('French'),
        de: __('German'),
        nl: __('Dutch'),
        el: __('Greek'),
        es: __('Spanish'),
        it: __('Italian'),
        ru: __('Russian'),
        pl: __('Polish'),
        cz: __('Czech'),
      };
      return labels[language] || __(language);
    },
  },
};
</script>